/*
 * @Author: lvjun
 * @Date: 2021-01-27 16:51:53
 * @Description: 各环境下的请求地址配置
 */

const { VUE_APP_ENV, VUE_APP_API_URL, VUE_APP_API_URL_GW, VUE_APP_GATEWAY = '' } = process.env

const img_url = '/file/file/upload'

//  基本请求
export const BASE_URL = VUE_APP_API_URL

//  图片上传
export const IMG_URL = VUE_APP_API_URL + img_url

//  公共请求
export const GW_URL = VUE_APP_API_URL_GW


// 后端接口返回的状态码常量
export const RESPONSE_CODE = {
  SUCCESS: 1, // 成功
  SUCCESS_COPY: 1, // 成功 临时使用
  EXPIRED: '000002' // token过期
}

// 应用的环境变量
export const APP_ENV = VUE_APP_ENV


// 网关标识
export const GATEWAY = VUE_APP_GATEWAY

// /lmdm
export const MODULE_LMDM = ''


// /oms
export const MODULE_OMS = ''

// 飞兔请求域名
export const FT_URL = {
  'pro':'https://imservice.jtexpress.com.cn',
  'uat':'https://uat-imservice.jtexpress.com.cn',
  'test':'http://test-imservice.jms.com',
  'dev':'http://dev-imservice.jms.com',
  'local':'https://uat-imservice.jtexpress.com.cn'
}












